import React from 'react'
import './ForAuthors.css'
import template from '../../assets/docs/conference-template-2025.docx'
import presentationSchedule2025 from '../../assets/docs/Paper presentaion_Program schedule for authors_ICIITCEE2025.pdf'
import pptTemplate from '../../assets/docs/ICIITCEE-2025_Ppt_template_BNMIT.pptx'
import Accommodation from '../../assets/docs/Accomodation_details.pdf'
const ForAuthors = () => {
    return (
        <div className='ForAuthors'>
            <h1 className="ch">For Authors</h1>
            
                
                {/* <div class="guidelines">
 <h2>📧 For any query Contact</h2>
  <ul style={{ lineHeight: "1.8" }}>
  <li>
    <strong>Deadline for Paper Submission:</strong> 31.10.2025{" "}
    <b style={{ color: "red" }}>(Submission Closed)</b>
  </li>

  <li>
    <strong>Acceptance Notification:</strong> Before 30th November 2025.
  </li>

  <li>
    <strong>Online/Offline Presentation:</strong> No Online presentation —{" "}
    <strong>Dr. Bindu S:</strong> 9606009793 (
    <i>
      Request can be sent to:{" "}
      <a href="mailto:iitcee2026.bnmit@gmail.com">
        iitcee2026.bnmit@gmail.com
      </a>
    </i>
    )
  </li>

  <li>
    <strong>Related to Author Registration and Payments:</strong>
    <br />
    Dr. Subodh Kumar Panda: 8147097272
    <br />
    Dr. Manjunath G Asuti:{" "}
    <a href="mailto:manjunathasuti@bnmit.in">
      manjunathasuti@bnmit.in
    </a>
  </li>

  <li>
    <strong>Camera Ready Paper Submission / Copyright:</strong>
    <br />
    Dr. Vrunda Kusanur:{" "}
    <a href="mailto:vrundakusanur@bnmit.in">vrundakusanur@bnmit.in</a> /
    8867703274
  </li>

  <li>
    <strong>
      Calls related to Multiple Paper Submission / Authors – IEEE / Non-IEEE:
    </strong>
    <br />
    Dr. Madhu S: 8867754418 /{" "}
    <a href="mailto:iitcee2026.bnmit@gmail.com">
      iitcee2026.bnmit@gmail.com
    </a>
  </li>
</ul>
</div>*/}

 <div class="guidelines">
 <h2 style={{ color:"#e63946" }}>📌 Paper Submission Guidelines</h2>
  <ul>
    <li><strong>Non‑presenting papers will not appear in the conference proceedings.</strong></li>
    <li><strong>All accepted and presented papers will be submitted for possible inclusion in the digital library.</strong></li>
    <li><strong>All papers must be original and must not be submitted simultaneously to another venue.</strong></li>
    <li><strong>Papers should be no longer than six pages and authored by no more than six people. An additional charge of Rs. 500/- per extra page applies.</strong> </li>
    <li><strong>Manuscripts must be prepared in the two‑column paper format (templates available via the conference link).                       </strong> </li>
    <li><strong>The overall similarity rate (using Turnitin) of a conference paper submission should be less than 20% (including reference material) and less than 10% (excluding reference material).</strong> </li>
    <li><strong>The similarity rate (using Turnitin) for a single source should be less than 2% (if any).</strong> </li>
    <li><strong>The Al-generated text (using Turnitin) must be 0%.</strong> </li>
  </ul>
</div>
                 <div>
<h2 className="tite">
  <i className="fa-solid fa-hand-point-right"></i>{" "}
  Submission link for ICIITCEE 2027 papers -{" "}
  <a
    href="https://cmt3.research.microsoft.com/User/Login?ReturnUrl=%2FIITCEE2027%2FSubmission%2FIndex"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      color: "blue",
      fontWeight: "bold",
      textDecoration: "underline",
    }}
  >
    Click here to submit your paper
  </a>
</h2>

 
 {/* <a
    href="https://cmt3.research.microsoft.com/User/Login?ReturnUrl=%2FIITCEE2026%2FSubmission%2Findex"
    target="_blank"
    rel="noreferrer"
    className="smalltite"
  >
    <button className="download-btn">Click to Submit</button>
  </a>*/}
  
  
  <style>
    {`
      @keyframes blink {
        50% { opacity: 0; }
      }
    `}
  </style>
</div>
                <div>
                    <h2 className="tite"><i className="fa-solid fa-hand-point-right"></i> The paper template for ICIITCEE 2027 Conference</h2>
                    <a href= {template} rel="noreferrer" target="_blank" download="IEEE-Conference-Template-2026.docx"
                        className="smalltite"><button className="download-btn">Download here</button></a>
                </div> 
                {/*
                 <p style={{ fontSize: '20px' }}><i className="fa-solid fa-hand-point-right"></i>REGISTRATION FOR ICIITCEE 2025 IS NOW CLOSED</p>
                <p style={{ fontSize: '20px' }}><i className="fa-solid fa-hand-point-right"></i>PAPER SUBMISSION IS NOW CLOSED FOR NEW SUBMISSIONS</p> 
                <p style={{ fontSize: '20px' }}><i className="fa-solid fa-hand-point-right"></i> Presentation Schedule for ICIITCEE 2026:</p><a href={presentationSchedule2025} download="presentationScheduleICIITCEE2025.pdf" className="smalltite"><button
                    className="download-btn">Download Presentation Schedule</button></a>
                <p style={{ fontSize: '20px' }}><i className="fa-solid fa-hand-point-right"></i> Presentation Template for ICIITCEE 2026:</p><p style={{ fontSize: '15px' }}>*Important Notice for Presenters
                    All authors are required to use the official PowerPoint Template for their presentations at the IEEE International Conference*</p><a href={pptTemplate} download="pptTemplateICIITCEE2025.pdf" className="smalltite"><button
                        className="download-btn">Download Presentation Template</button></a>

                <p style={{ fontSize: '20px' }}><i className="fa-solid fa-hand-point-right"></i> Presentation Guidelines:</p>
                <ul style={{ paddingLeft: "2rem", fontSize: "15px" }}>
                    <li style={{ textTransform: "none" }}>&mdash;&nbsp;&nbsp;Slide Limit: Maximum of 8 to 10 slides.
                    </li>
                    <li style={{ textTransform: "none" }}>&mdash;&nbsp;&nbsp;Duration: 8 minutes for the presentation and 2 minutes for Q&A.</li>
                    <li style={{ textTransform: "none" }}>&mdash;&nbsp;&nbsp;Template: Download the PPT Template above.</li>
                </ul>
                    
                <p style={{ fontSize: '20px' }}><i className="fa-solid fa-hand-point-right"></i> Content Focus:</p>
                <p style={{ fontSize: '15px' }}><b>Your slides should highlight the key aspects of your research, such as:</b></p>
                <ul style={{ paddingLeft: "2rem", fontSize: "15px" }}>
                    <li style={{ textTransform: "none" }}>&mdash;&nbsp;&nbsp;Introduction</li>
                    <li style={{ textTransform: "none" }}>&mdash;&nbsp;&nbsp;Problem Statement</li>
                    <li style={{ textTransform: "none" }}>&mdash;&nbsp;&nbsp;Methodology</li>
                    <li style={{ textTransform: "none" }}>&mdash;&nbsp;&nbsp;Results and Analysis</li>
                    <li style={{ textTransform: "none" }}>&mdash;&nbsp;&nbsp;Conclusion and Future Work</li>
                </ul>

                <p style={{ fontSize: '20px' }}><i className="fa-solid fa-hand-point-right"></i> Near-by Hotels for Accommodation</p><a href={Accommodation} download="Accomodation_details.pdf" className="smalltite"><button
                        className="download-btn">Download details</button></a> 
                        */}
            </div>
        
             
     
    )
}

export default ForAuthors